import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { Col, Row } from 'reactstrap';
import $ from 'jquery';
import uuid from 'uuid';
import DataLoader from '../../../app/DataLoader'
// import { signout } from '../../../redux/actions/userActions';
import TypeformView from '../TypeformView'

class SecurityAwareness extends PureComponent {
	static propTypes = {
		items: PropTypes.object
	};

	state = {
		categoryIndex: 0,
		isActive: true,
		hoverColor: true,
		bgColr: "white-bg",
		loading: true,
		loaded: false,
		updateForm: true,
		forms: []
	}

	scrollContent(direction) {
		const step = 370;

		$("#card-content").animate({
			scrollLeft: `${direction === 'left' ? '-=' : '+='}` + step + "px"
		});
	}

	setUpdate = (title, active) => {
		this.setState({ updateForm: (title !== active) })
	}

	selectNewCatagory(category) {
		this.setState({ categoryIndex: category });
	}

	componentDidMount() {
		let forms
		
		if(["prod"].includes(process.env.REACT_APP_ENV))
		{
			forms = [
				{
					name: 'Security Awareness Quiz',
					url: `https://postured.typeform.com/to/OLVdenyo#`,
					description: 'Step 3'
				}
			]
		}
		else{
			forms = [
				{
					name: 'Security Awareness Quiz',
					url: `https://postured.typeform.com/to/nez220Io#`,
					description: 'Step 3'
				}
			]
		}


		this.setState({ forms: forms })
	}

	render() {
		return (
			<DataLoader>
				<div className="comp-assessment">
					<div>
						<Row>
							<Col md={12} id="test">
								<h3 className='page-title'>Take Security Awareness Quiz</h3>
								{/* <h3 className='page-subhead subhead'>
			  Determine the state of your company's compliance health</h3> */}
							</Col>
							<Col md={12}>
								<button
									className="btn btn-secondary"
									onClick={() => {
									this.props.history.push("/app/training/security");
									}}
									style={{
									marginLeft: "15px"
									}}
								>
									{" "}
									{"<< Back To Security Training"}
								</button>
							</Col>
						</Row>
					</div>

					{
						this.state.forms.map((category, idx) => {
							return <div key={uuid()}>
									<TypeformView
									categoryIndex={this.state.categoryIndex}
									i={idx}
									url={`${category.url}&email=${this.props.user.email.replace('+','%2B')}`+
									`&tenantname=${this.props.tenant ? this.props.tenant.companyName: ""}`}
									frameworkName="securityquiz"
									email={this.props.user.email} 
									/>
							</div>
						}
						)
					}
				</div >
			</DataLoader>
		);
	}
}


function mapStateToProps(state) {
	return {
		user: state.auth.user,
		tenant: state.auth.tenant,
		enabledFrameworks: state.controlsData.enabledFrameworks,
		dataLoaded: !state.controlsData.loading,
		sidebar: state.sidebar
	}
}

export default connect(mapStateToProps)(withRouter(SecurityAwareness))


// WEBPACK FOOTER //
// ./src/components/training/components/SecurityAwareness.js